export function firstFromNullable<T>(arr: Array<T> | null | undefined): T | undefined {
  return arr ? arr[0] : undefined;
}

export function nullableToArray<T>(t: T | null | undefined): Array<T> {
  return typeof t !== "undefined" && t !== null ? [t] : [];
}
